<template>
    <div>
        <!--
        <div class="maintenance" v-if="this.$route.name == 'maintenance'">
            <router-view/>
        </div>
        <div v-else>
        -->

            <Navigation />

            <main>
                <router-view/>
            </main>

            <Footer />

            <!-- notification modal -->
            <!--<ModalNotification ref="notification"/>-->
        <!--    
        </div>
        -->
    </div>
</template>

<script>
  export default {
    name: 'app',
    metaInfo: {
      title: 'Un voucher per viaggiare',
      titleTemplate: '%s - ' + process.env.VUE_APP_SITE_TITLE,
      meta: [
        { vmid: 'metaDescription', name: 'Description', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. Salabam, soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
        { vmid: 'metaAbstract', name: 'abstract', content: 'Salabam è un servizio di prenotazione viaggi online pensato per gli utenti del welfare aziendale. Salabam offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi' },
        { vmid: 'metaClassification', name: 'Classification', content: 'Commercial' },
        { vmid: 'metaResourceType', name: 'resource-type', content: 'document' },
        { vmid: 'metaDistribution', name: 'Distribution', content: 'Global' },
        { vmid: 'metaRating', name: 'Rating', content: 'General' },
        { vmid: 'metaLanguage', name: 'Language', content: 'IT' },
        { vmid: 'metaOwner', name: 'Owner', content: 'Salabam SRL' },
        { vmid: 'ogTitle', property: 'og:title', content: 'Prenota online in tempo reale hotel, beb, appartamenti e ville' },
        { vmid: 'ogSiteName', name: 'site_name', content: 'Salabam | viaggi online' },
        { vmid: 'ogType', name: 'og:type', content: 'website' },
        { vmid: 'ogUrl', name: 'og:url', content: process.env.VUE_APP_SITE_HOST },
        { vmid: 'ogImage', name: 'og:image', content: process.env.VUE_APP_SITE_HOST + 'assets/salabam_logo_512.png' },
        { vmid: 'ogImageWidth', name: 'og:image:width', content: '512' },
        { vmid: 'ogImageHeight', name: 'og:image:height', content: '512' },
        { vmid: 'ogDescription', name: 'og:description', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. Salabam, soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
        { vmid: 'dcTitle', name: 'DC.title', lang: 'it', content: 'Prenota online i tuoi viaggi in modo semplice e soprattutto sicuro. Salabam, soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni' },
        { vmid: 'dcCreator', name: 'DC.creator', content: 'Salabam SRL' },
        { vmid: 'dcSubject', name: 'DC.subject', lang: 'it', content: 'salabam;viaggi online;online travel booking;online travel agency;agenzia viaggi online;prenotazione online viaggi;viaggi welfare aziendale;viaggi welfare;viaggi promozioni;viaggi marketing;viaggi viaggi programmi fedeltà;viaggi programma fedeltà;viaggi loyalty program;catalogo a premi viaggi' },
        { vmid: 'dcDescription', name: 'DC.description', lang: 'it', content: 'Salabam è un servizio di prenotazione viaggi online pensato per gli utenti del welfare aziendale. Salabam offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi' },
        { vmid: 'dcType', name: 'DC.type', scheme: 'DCTERMS.DCMIType', content: 'Text' },
        { vmid: 'dcFormat', name: 'DC.format', content: 'text/html' },
        { vmid: 'dcIdentifier', name: 'DC.identifier', scheme: 'DCTERMS.URI', content: process.env.VUE_APP_SITE_HOST },
        { vmid: 'dcLanguage', name: 'DC.language', scheme: 'DCTERMS.RFC1766', content: 'IT' },
        { vmid: 'robots', name: 'robots', content: process.env.VUE_APP_META_ROBOTS },
      ]
    },
    components: {
        Navigation: () => import('@/components/blocks/navigation').then(function(Navigation) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Navigation Component loaded')
            return Navigation
        }),
        Footer: () => import('@/components/blocks/footer').then(function(Footer) {
            if(process.env.VUE_APP_MODE != 'production') window.console.log('async: Footer Component loaded')
            return Footer
        }),
    },
    beforeMount() {
    },
    watch: {
    },
    mounted()
    {
        /*
        let _this = this
        window.eventBus.$on('gotNotification', function(data) { 
            _this.$refs.notification.handleNotification(data)
        })
        */
    },
    created () {
    },
    destroyed () {
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  //@import 'scss/_bootstrap.scss';
  //@import 'scss/_font-poppins.scss';
  //@import 'scss/_font-yantramanov.scss';
  //@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700&display=swap');
  @import 'scss/_app.scss';
</style>